// BM-H398 - the client-facing step order.
//
// `key` is the engine's `submission.answers` key, a guide-only step that
// writes into one of those keys (`g3_marriage` writes `s1_testator`), or one
// of the two non-answer screens (`capacity_gate`, `review`). `guide` is the
// Client Guide section, written G-n per the 23 Sep 2026 ruling: three
// prefixes, one meaning each (C- clause register, S answers keys, G- guide).

export const WILLS_SECTIONS = [
  { key: "capacity_gate", guide: null, label: "Before we start" },
  { key: "s1_testator", guide: "G-1", label: "About you" },
  { key: "s2_family", guide: "G-2", label: "Your family" },
  { key: "g3_marriage", guide: "G-3", label: "Marriage in contemplation", writes: "s1_testator" },
  { key: "s2a_joint_assets", guide: "G-1", label: "Your home and property" },
  { key: "s2b_shares", guide: "G-9", label: "Business and farming interests" },
  { key: "s3_executors", guide: "G-4", label: "Your executors and trustees" },
  { key: "s4_guardians", guide: "G-5", label: "Guardians for your children", conditional: "minor_children" },
  { key: "s5_structure", guide: "G-8", label: "How your estate should pass" },
  { key: "s6_legacies", guide: "G-7", label: "Specific gifts" },
  { key: "s7_residue", guide: "G-8", label: "The rest of your estate" },
  { key: "s8_digital", guide: "G-9", label: "Digital assets" },
  { key: "s9_funeral", guide: "G-6", label: "Funeral wishes" },
  { key: "s10_exclusions", guide: "G-9", label: "People you are leaving out" },
  { key: "s11_letter_of_wishes", guide: "G-9", label: "Letter of wishes" },
  { key: "review", guide: "G-10", label: "Review and submit" },
];

export const ANSWER_SECTION_KEYS = WILLS_SECTIONS
  .map((s) => s.key)
  .filter((k) => !["capacity_gate", "review", "g3_marriage"].includes(k));

export function sectionLabel(key) {
  return WILLS_SECTIONS.find((s) => s.key === key)?.label || key;
}

// The steps this client sees. Guardians only when a child is under 18 at
// submission (C-08 gate); marriage in contemplation only when not married.
export function visibleSections({ hasMinorChildren, relationshipStatus }) {
  return WILLS_SECTIONS.filter((s) => {
    if (s.key === "s4_guardians") return hasMinorChildren;
    if (s.key === "g3_marriage") return relationshipStatus !== "married" && relationshipStatus !== "civil_partnership";
    return true;
  });
}
